import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { oauthService } from '@/api/services/oauth';

// Auth0's post-login Action redirects here with these two parameters (design §6.5).
const consentSearchSchema = z.object({
  session_token: z.string().min(1),
  state: z.string().min(1),
});

export const Route = createFileRoute('/_authenticated/oauth/consent')({
  validateSearch: consentSearchSchema,
  beforeLoad: ({ search: { session_token } }) => ({
    consentRequestQuery: oauthService.getOAuthConsentRequestQuery({ sessionToken: session_token }),
  }),
  loader: ({ context: { queryClient, consentRequestQuery } }) => queryClient.prefetchQuery(consentRequestQuery),
  staticData: {
    title: 'Connect an App',
    domain: 'iam',
  },
  component: lazyRouteComponent(() => import('./consent.component'), 'OAuthConsentComponent'),
  pendingComponent: lazyRouteComponent(() => import('./consent.component'), 'OAuthConsentPendingComponent'),
});
